<template>
  <div class="ele-table">
    <el-table
      :data="tableData"
      style="width: 100%"
      :max-height="maxHeight || undefined"
      size="mini"
      stripe
      :row-style="{height: '0'}"
      :cell-style="{padding: '0'}"
      @row-click="handleRow"
    >
        <template v-for="(item, index) in tableTitle">
          <el-table-column
            :key="index"
            :label="item.label"
            v-if="item.type === 'indexAndSelection'"
            :type="item.prop"
            align="center"
          />
          <el-table-column
            v-else
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :align="item.align ? item.align : 'center'"
          >
            <template v-slot="{ row }">
              <slot :name="item.prop" :rowDate="row">
                <el-tooltip class="item" effect="dark" :content="row[item.prop]" placement="top-start">
                  <div>{{ row[item.prop] }} {{ row.visible }}</div>
                </el-tooltip>
              </slot>
            </template>
          </el-table-column>
        </template>
    </el-table>
  </div>
</template>

<script>
import { number } from 'echarts';
export default {
  name: 'BaseTable',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    tableTitle: {
      type: Array,
      default() {
        return [];
      },
    },
    maxHeight: {
      type: [String, number],
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    formatter:function (row,col){
      return "a";
    },

    headerCellStyle() {
      return 'border: 0;color: #00e1ff;font-size: 14px;height: 22px;';
    },
    cellStyle({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'background: transparent;color: #fff;border: 0;padding: 4px 0 !important;';
      }
      return 'background: rgba(39, 104, 136, 0.3);color: #fff;border: 0;padding: 4px 0 !important;';
    },
    handleRow(row) {
      this.$emit('handleRow', row);
    }
  },
};
</script>

<style scoped>
.rowclass{
  height: 35px;
}

.cell{
  height: 20px;
  line-height: 20px;
}

table tbody td{
  margin: 0px;
}

::v-deep .cell div {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
